export default {
  save: 'Salvar',
  cancel: 'Cancelar',
  delete: 'Excluir',
  edit: 'Editar',
  back: 'Voltar',
  next: 'Próximo',
  previous: 'Anterior',
  confirm: 'Confirmar',
  close: 'Fechar',
  search: 'Pesquisar',
  loading: 'Carregando…',
  load_failed: 'Não foi possível carregar.',
  next_page: 'Próxima página',
  prev_page: 'Página anterior',
  retry: 'Tentar novamente',
  yes: 'Sim',
  no: 'Não',
  all: 'Todos',
  none: 'Nenhum',
  optional: 'Opcional',
  required: 'Obrigatório',
  actions: 'Ações',
  status: 'Status',
  name: 'Nome',
  email: 'E-mail',
  phone: 'Telefone',
  language: 'Idioma',
  select_language: 'Selecionar idioma',
  created_at: 'Criado em',
  updated_at: 'Atualizado em',
  empty_generic: 'Nenhum registro encontrado.',
  error_generic: 'Algo deu errado. Tente novamente.',
  session_expired: 'Sessão expirada. Entre novamente.',
  no_results: 'Nenhum resultado para essa busca.',
  show_all: 'Ver todos',
  see_more: 'Ver mais',
  done: 'Concluído',
  send: 'Enviar',
  copy: 'Copiar',
  copied: 'Copiado!',
  remove: 'Remover',
  add: 'Adicionar',
  new: 'Novo',
  per_page: 'por página',
  page_of: 'Página {page} de {total}',
  selected_count: '{count} selecionado | {count} selecionados',
  never: 'Nunca',
  today: 'Hoje',
  yesterday: 'Ontem',
  days_ago: 'há {count} dia | há {count} dias',
  active: 'Ativo',
  inactive: 'Inativo',
  enabled: 'Ativado',
  disabled: 'Desativado',
  battery: 'Bateria',
  accuracy: 'Precisão',
  source: 'Origem',
  address: 'Endereço',
  date: 'Data',
  time: 'Horário',
  group: 'Grupo',
  clear_filters: 'Limpar filtros',
  type: 'Tipo',
  details: 'Detalhes',
  open: 'Abrir',
  view: 'Ver',
  download: 'Baixar',
  print: 'Imprimir',
  filter: 'Filtrar',
  filters: 'Filtros',
  clear: 'Limpar',
  apply: 'Aplicar',
  reset: 'Redefinir',
  continue: 'Continuar',
  finish: 'Finalizar',
  skip: 'Pular',
  or: 'ou',
  and: 'e',
  at: 'em',
  load_more: 'Carregar mais',
  retry_hint: 'Tente novamente em instantes.',
  show_password: 'Mostrar senha',
  hide_password: 'Ocultar senha',
}
